import BaseButton from 'src/components/BaseButton';

type Props = {
  ProviderLogo: React.ReactNode;
  text: string;
  onClick?: () => void;
};

const SocialButton = ({ProviderLogo, text, onClick}: Props) => {
  return (
    <BaseButton variant="secondary" size="large" className="px-3" onClick={onClick}>
      {ProviderLogo ? <div className="rounded-full w-7 h-7 bg-white shadow">{ProviderLogo}</div> : null}

      <div className="text-center grow text-sm">{text}</div>
    </BaseButton>
  );
};

export default SocialButton;
